export default __webpack_public_path__ + "images/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91.png";